import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  setCompanyVerified,
  verifyCompanyInitiate,
} from '../../actions/company';
import {
  setUploadMsg,
  uploadEmployeesClear,
  uploadEmployeesInitiate,
} from '../../actions/employee';
import { clearSuccessModal, setSuccessModal } from '../../actions/uiLogic';
import { openErrorToast } from '../../reducers/uiLogic';
import { employeeUploadMsg } from '../common/components/constants';
import Onboarding from './Onboarding';

const mapStateToProps = state => {
  const verified = _get(state, 'company.verified', false);
  const companyVerification = _get(state, 'apiState.VERIFY_COMPANY', {});
  const employeeUpload = _get(state, 'apiState.UPLOAD_EMPLOYEES', {});
  const companyProfile = _get(state, 'apiState.GET_COMPANY_PROFILE', {});

  return {
    verified,
    companyData: _get(state, 'company', {}),
    uploadMsg: _get(state, 'employees.uploadMsg', employeeUploadMsg),
    processId: _get(state, 'employees.processId', ''),
    companyProfileFetched: _get(companyProfile, 'success', true),
    isVerifying:
      _get(companyVerification, 'isFetching', false) &&
      !_get(companyVerification, 'isIdle', false),
    verificationSuccess: _get(companyVerification, 'success', false),
    fileUploading:
      _get(employeeUpload, 'isFetching', false) &&
      !_get(employeeUpload, 'isIdle', false),
    fileUploaded: _get(employeeUpload, 'success', false),
  };
};

const mapDispatchToProps = dispatch => ({
  uploadEmployees: payload => dispatch(uploadEmployeesInitiate(payload)),
  verifyCompany: () => dispatch(verifyCompanyInitiate()),
  setSuccessModal: payload => dispatch(setSuccessModal(payload)),
  clearSuccessModal: () => dispatch(clearSuccessModal()),
  clearUpload: () => dispatch(uploadEmployeesClear()),
  setCompanyVerified: payload => dispatch(setCompanyVerified(payload)),
  showErrorToast: message => dispatch(openErrorToast(message)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Onboarding);
